import NothingFound from "../NothingFound";
import { useDispatch, useSelector } from "react-redux";
import PodcastDetailInfo from "../PodcastDetailInfo";
import {
  FixedDiv,
  ReleaseTextModalWrapper,
  StyledPodcastDetailInfo,
  StyledReleasesList,
} from "./styled";
import ReleaseText from "../ReleaseText";
import ReleasesList from "../ReleasesList";
import { closeModal, openModal } from "../../redux/Slice/modalSlice";
import { modalState } from "../../utils/constants";
import {
  useGetPodcastsQuery,
  useGetReleasesQuery,
} from "../../api/podcastsApi";
import PageContainer from "../PageContainer";
import { Center } from "../../App/styled";
import Loader from "../Loader/Loader";
import { setReleasePodcastInfo } from "../../redux/Slice/releasePodcastSlice";

export const ReleaseTextModal = () => {
  const dispatch = useDispatch();
  const currentContent = useSelector((state) => state.player.currentContent);

  const {
    data: releasesData,
    isLoading: releasesDataLoading,
    isError: isReleasesError,
  } = useGetReleasesQuery();

  const {
    data: playingReleasePodcast,
    isLoading: playingReleasePodcastLoading,
  } = useGetPodcastsQuery({ link: currentContent.podcastId });

  const handleClickCardRelease = (release) => {
    dispatch(setReleasePodcastInfo(release));

    dispatch(openModal(modalState.RELEASE_PODCAST_INFO));
  };

  const releases = releasesData?.latestPodcastReleases.filter(
    (release) => !release.isLive,
  );

  const closeTextHandler = () => {
    dispatch(closeModal(modalState.RELEASE_TEXT));
  };

  if (playingReleasePodcastLoading || releasesDataLoading) {
    return (
      <Center>
        <Loader color="#fff" />
      </Center>
    );
  }

  if (isReleasesError) {
    return <NothingFound onClick={closeTextHandler} />;
  }

  return (
    <ReleaseTextModalWrapper as={PageContainer}>
      <FixedDiv>
        <StyledPodcastDetailInfo>
          <PodcastDetailInfo podcast={playingReleasePodcast} />
        </StyledPodcastDetailInfo>
        <StyledReleasesList>
          <ReleasesList
            releases={releases.filter(
              (release) => release.podcastId === currentContent.podcastId,
            )}
            releasesPodcast={playingReleasePodcast.podcastReleases}
            showPodcastInfo={false}
            onClickCardRelease={handleClickCardRelease}
          />
        </StyledReleasesList>
      </FixedDiv>
      {currentContent.textFileLink ? (
        <ReleaseText releaseTextLink={currentContent.textFileLink} />
      ) : (
        <div>Тексты не найдены</div>
      )}
    </ReleaseTextModalWrapper>
  );
};
